// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M18.5 1.58594L22.9142 6.00016L21.5 7.41437L19.5 5.41436L19.5 18.5859L21.5 16.5859L22.9142 18.0001L18.5 22.4144L14.0858 18.0002L15.5 16.5859L17.5 18.5859L17.5 5.41437L15.5 7.41436L14.0858 6.00015L18.5 1.58594ZM2 2.00015H12V22.0002H2V2.00015Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-measurement-2-filled')
export default class Measurement2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'measurement-2-filled',
    }
  }
}
